import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";
import router from "@/router";

// CONFIGURAÇÃO DE COSTUMIZAÇÃO

Vue.prototype.$pessoas_agentes = new Vue({
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      access_token: false,
      modalAlertSucesso: false,
      agentesAddEdit: "new",
      logado: false,
      modalEvento: {
        show: false,
        text: "",
      },
      menu: {
        show: false,
        loading: false,
      },
      cadastro: {
        idagente: "",
        loading: false,
        dados_cadastrais: {
          razao_social: "",
          cnpj: "",
          nome_representante: "",
          cpf: "",
          rg: "",
          rg_orgao: "",
          email: "",
          celular: "",
          regional: "",
          status: "",
          cep: "",
          estado: "",
          cidade: "",
          bairro: "",
          logradouro: "",
          complemento: "",
          error: {
            razao_social: [],
            cnpj: [],
            nome_representante: [],
            cpf: [],
            rg: [],
            rg_orgao: [],
            email: [],
            celular: [],
            regional: [],
            status: [],
            cep: [],
            estado: [],
            cidade: [],
            bairro: [],
            logradouro: [],
          },
        },
        comissao_antecipacao: {
          comissao: "",
          porcentagem_web: "",
          porcentagem_rede: "",
          antecipacao: "",
          taxa_personalizada: "",
          dias_antecipacao: "",
          taxa_mes: "",
          observacoes: "",
          error: {
            comissao: [],
            porcentagem_web: [],
            porcentagem_rede: [],
            antecipacao: [],
            taxa_personalizada: [],
            dias_antecipacao: [],
            taxa_mes: [],
          },
        },
        dados_bancarios: {
          nome_titular: "",
          banco: "",
          agencia: "",
          tipo_de_conta: "corrente",
          numero_conta: "",
          digito: "",
          error: {
            nome_titular: [],
            banco: [],
            agencia: [],
            tipo_de_conta: [],
            numero_conta: [],
            digito: [],
          },
        },
        documentos: {
          contrato_social: "",
          comprovante_endereco: "",
          procuracao: "",
          error: {
            contrato_social: [],
            comprovante_endereco: [],
          },
        },
        contratos: {
          template: "",
          error: {
            template: [],
          },
        },
      },
      agentes: [],
      filtros: [],
      filter: {
        nome: "",
        documento: "",
        status: "",
        dataInicio: "",
        dataFim: "",
        tipo_pessoa: "",
      },
    };
  },

  methods: {
    // ---- LOGIN ---- //
    getLogin(user, senha) {
      this.cadastro.loading = true;
      this.$axios
        .post(
          this.ENDPOINTS.LOGIN,
          JSON.stringify({ email: user, senha: senha })
        )
        .then(response => {
          if (response && response.access_token) {
            this.$axios.setLocal("oe_jwt", response.access_token);
            let dados = response.info;
            if (dados) {
              this.$axios.setLocal("oe_user_info", dados);
              this.$axios.setLocal("confirm_login", true);
              this.logado = true;
              router.push("/home");
            } else {
              if (location.pathname != "login") {
                router.push("/");
              } else {
                window.scrollTo({
                  top: 750,
                  left: 0,
                  behavior: "smooth",
                });
              }
            }
          }
          this.cadastro.loading = false;
        })
        .catch(() => {
          this.cadastro.loading = false;
        });
    },

    // ---- LISTAR AGENTES ---- //
    getAgentes() {
      this.cadastro.loading = true;
      this.$axios.post(this.ENDPOINTS.LISTAR_AGENTES).then(response => {
        if (response) {
          this.agentes = response;
          this.$axios.setLocal("agentes", response);
          this.cadastro.loading = false;
        }
      });
    },

    // ---- DESABILITAR AGENTE ---- //
    desabilitarAgente(idagente) {
      this.$axios.put(this.ENDPOINTS.DESABILITAR_AGENTE + idagente).then(() => {
        document.location.reload();
      });
    },

    // ---- ALTERAR AGENTE ---- //
    alterarAgente() {
      this.cadastro.loading = true;
      let dados = {
        // dados cadastrais
        senha: "",
        status: this.cadastro.dados_cadastrais.status,
        razao_social: this.cadastro.dados_cadastrais.razao_social,
        cnpj: this.cadastro.dados_cadastrais.cnpj,
        end_cep: this.cadastro.dados_cadastrais.cep,
        end_estado: this.cadastro.dados_cadastrais.estado,
        end_cidade: this.cadastro.dados_cadastrais.cidade,
        end_bairro: this.cadastro.dados_cadastrais.bairro,
        end_logradouro: this.cadastro.dados_cadastrais.logradouro,
        end_complemento: this.cadastro.dados_cadastrais.complemento,
        representante_nome: this.cadastro.dados_cadastrais.nome_representante,
        representante_cpf: this.cadastro.dados_cadastrais.cpf,
        representante_rg: this.cadastro.dados_cadastrais.rg,
        representante_rg_orgao: this.cadastro.dados_cadastrais.rg_orgao,
        representante_email: this.cadastro.dados_cadastrais.email,
        celular: this.cadastro.dados_cadastrais.celular,
        nidregional: this.cadastro.dados_cadastrais.regional,
        isadmin: true,
      };

      // let dados = {
      //     dados_cadastrais: {
      //         senha: "",
      //         status: this.cadastro.dados_cadastrais.status,
      //         razao_social: this.cadastro.dados_cadastrais.razao_social,
      //         cnpj: this.cadastro.dados_cadastrais.cnpj,
      //         end_cep: this.cadastro.dados_cadastrais.cep,
      //         end_estado: this.cadastro.dados_cadastrais.estado,
      //         end_cidade: this.cadastro.dados_cadastrais.cidade,
      //         end_bairro: this.cadastro.dados_cadastrais.bairro,
      //         end_logradouro: this.cadastro.dados_cadastrais.logradouro,
      //         end_complemento: this.cadastro.dados_cadastrais.complemento,
      //         representante_nome: this.cadastro.dados_cadastrais.nome_representante,
      //         representante_cpf: this.cadastro.dados_cadastrais.cpf,
      //         representante_rg: this.cadastro.dados_cadastrais.rg,
      //         representante_rg_orgao: this.cadastro.dados_cadastrais.rg_orgao,
      //         representante_email: this.cadastro.dados_cadastrais.email,
      //         celular: this.cadastro.dados_cadastrais.celular,
      //         nidregional: this.cadastro.dados_cadastrais.regional,
      //         isadmin: true
      //     },
      //     comissao_antecipacao: {
      //         comissao: this.cadastro.comissao_antecipacao.comissao,
      //         porcentagem_web: this.cadastro.comissao_antecipacao.porcentagem_web,
      //         porcentagem_rede: this.cadastro.comissao_antecipacao.porcentagem_rede,
      //         antecipacao: this.cadastro.comissao_antecipacao.antecipacao,
      //         taxa_personalizada: this.cadastro.comissao_antecipacao.taxa_personalizada,
      //         dias_antecipacao: this.cadastro.comissao_antecipacao.dias_antecipacao,
      //         taxa_mes: this.cadastro.comissao_antecipacao.taxa_mes,
      //         observacoes: this.cadastro.comissao_antecipacao.observacoes,
      //     },
      //     dados_bancarios: {
      //         nome_titular: this.cadastro.dados_bancarios.nome_titular,
      //         banco: this.cadastro.dados_bancarios.banco,
      //         agencia: this.cadastro.dados_bancarios.agencia,
      //         tipo_de_conta: this.cadastro.dados_bancarios.tipo_de_conta,
      //         numero_conta: this.cadastro.dados_bancarios.numero_conta,
      //         digito: this.cadastro.dados_bancarios.digito,
      //     },
      //     documentos: {
      //         contrato_social: this.cadastro.documentos.contrato_social,
      //         comprovante_endereco: this.cadastro.documentos.comprovante_endereco,
      //         procuracao: this.cadastro.documentos.procuracao,
      //     },
      //     contratos: {
      //         template: this.cadastro.contratos.template,
      //     },
      // }

      this.$axios
        .put(this.ENDPOINTS.ALTERAR_AGENTE + this.cadastro.idagente, dados)
        .then(response => {
          if (response) {
            this.$axios.setLocal("confirmEditAgente", true);
            // dados cadastrais
            (this.cadastro.dados_cadastrais.status = "ATIVO"),
              (this.cadastro.dados_cadastrais.razao_social = ""),
              (this.cadastro.dados_cadastrais.cnpj = ""),
              (this.cadastro.dados_cadastrais.cep = ""),
              (this.cadastro.dados_cadastrais.estado = ""),
              (this.cadastro.dados_cadastrais.cidade = ""),
              (this.cadastro.dados_cadastrais.bairro = ""),
              (this.cadastro.dados_cadastrais.logradouro = ""),
              (this.cadastro.dados_cadastrais.complemento = ""),
              (this.cadastro.dados_cadastrais.nome_representante = ""),
              (this.cadastro.dados_cadastrais.cpf = ""),
              (this.cadastro.dados_cadastrais.rg = ""),
              (this.cadastro.dados_cadastrais.rg_orgao = ""),
              (this.cadastro.dados_cadastrais.email = ""),
              (this.cadastro.dados_cadastrais.celular = ""),
              (this.cadastro.dados_cadastrais.regional = "");

            // comissao e antecipacao
            (this.cadastro.comissao_antecipacao.comissao = ""),
              (this.cadastro.comissao_antecipacao.porcentagem_web = ""),
              (this.cadastro.comissao_antecipacao.porcentagem_rede = ""),
              (this.cadastro.comissao_antecipacao.antecipacao = ""),
              (this.cadastro.comissao_antecipacao.taxa_personalizada = ""),
              (this.cadastro.comissao_antecipacao.dias_antecipacao = ""),
              (this.cadastro.comissao_antecipacao.taxa_mes = ""),
              (this.cadastro.comissao_antecipacao.observacoes = ""),
              // dados bancarios
              (this.cadastro.dados_bancarios.nome_titular = ""),
              (this.cadastro.dados_bancarios.banco = ""),
              (this.cadastro.dados_bancarios.agencia = ""),
              (this.cadastro.dados_bancarios.tipo_de_conta = ""),
              (this.cadastro.dados_bancarios.nome_titular = ""),
              (this.cadastro.dados_bancarios.numero_conta = ""),
              (this.cadastro.dados_bancarios.digito = ""),
              // documentos
              (this.cadastro.documentos.contrato_social = ""),
              (this.cadastro.documentos.comprovante_endereco = ""),
              (this.cadastro.documentos.procuracao = ""),
              // contratos
              (this.cadastro.contratos.template = "");
            router.push("/pessoas/agentes");
          }
          this.cadastro.loading = false;
        })
        .catch(() => {
          this.cadastro.loading = false;
        });
    },

    // ---- CADASTRAR AGENTE ---- //
    async cadastrarAgente() {
      this.cadastro.loading = true;
      let dados = {
        senha: "",
        status: this.cadastro.dados_cadastrais.status,
        razao_social: this.cadastro.dados_cadastrais.razao_social,
        cnpj: this.cadastro.dados_cadastrais.cnpj,
        end_cep: this.cadastro.dados_cadastrais.cep,
        end_estado: this.cadastro.dados_cadastrais.estado,
        end_cidade: this.cadastro.dados_cadastrais.cidade,
        end_bairro: this.cadastro.dados_cadastrais.bairro,
        end_logradouro: this.cadastro.dados_cadastrais.logradouro,
        end_complemento: this.cadastro.dados_cadastrais.complemento,
        representante_nome: this.cadastro.dados_cadastrais.nome_representante,
        representante_cpf: this.cadastro.dados_cadastrais.cpf,
        representante_rg: this.cadastro.dados_cadastrais.rg,
        representante_rg_orgao: this.cadastro.dados_cadastrais.rg_orgao,
        representante_email: this.cadastro.dados_cadastrais.email,
        celular: this.cadastro.dados_cadastrais.celular,
        nidregional: this.cadastro.dados_cadastrais.regional,
        isadmin: true,
      };
      // let dados = {
      //     dados_cadastrais: {
      //         senha: "",
      //         status: this.cadastro.dados_cadastrais.status,
      //         razao_social: this.cadastro.dados_cadastrais.razao_social,
      //         cnpj: this.cadastro.dados_cadastrais.cnpj,
      //         end_cep: this.cadastro.dados_cadastrais.cep,
      //         end_estado: this.cadastro.dados_cadastrais.estado,
      //         end_cidade: this.cadastro.dados_cadastrais.cidade,
      //         end_bairro: this.cadastro.dados_cadastrais.bairro,
      //         end_logradouro: this.cadastro.dados_cadastrais.logradouro,
      //         end_complemento: this.cadastro.dados_cadastrais.complemento,
      //         representante_nome: this.cadastro.dados_cadastrais.nome_representante,
      //         representante_cpf: this.cadastro.dados_cadastrais.cpf,
      //         representante_rg: this.cadastro.dados_cadastrais.rg,
      //         representante_rg_orgao: this.cadastro.dados_cadastrais.rg_orgao,
      //         representante_email: this.cadastro.dados_cadastrais.email,
      //         celular: this.cadastro.dados_cadastrais.celular,
      //         nidregional: this.cadastro.dados_cadastrais.regional,
      //         isadmin: true
      //     },
      //     comissao_antecipacao: {
      //         comissao: this.cadastro.comissao_antecipacao.comissao,
      //         porcentagem_web: this.cadastro.comissao_antecipacao.porcentagem_web,
      //         porcentagem_rede: this.cadastro.comissao_antecipacao.porcentagem_rede,
      //         antecipacao: this.cadastro.comissao_antecipacao.antecipacao,
      //         taxa_personalizada: this.cadastro.comissao_antecipacao.taxa_personalizada,
      //         dias_antecipacao: this.cadastro.comissao_antecipacao.dias_antecipacao,
      //         taxa_mes: this.cadastro.comissao_antecipacao.taxa_mes,
      //         observacoes: this.cadastro.comissao_antecipacao.observacoes,
      //     },
      //     dados_bancarios: {
      //         nome_titular: this.cadastro.dados_bancarios.nome_titular,
      //         banco: this.cadastro.dados_bancarios.banco,
      //         agencia: this.cadastro.dados_bancarios.agencia,
      //         tipo_de_conta: this.cadastro.dados_bancarios.tipo_de_conta,
      //         numero_conta: this.cadastro.dados_bancarios.numero_conta,
      //         digito: this.cadastro.dados_bancarios.digito,
      //     },
      //     documentos: {
      //         contrato_social: this.cadastro.documentos.contrato_social,
      //         comprovante_endereco: this.cadastro.documentos.comprovante_endereco,
      //         procuracao: this.cadastro.documentos.procuracao,
      //     },
      //     contratos: {
      //         template: this.cadastro.contratos.template,
      //     },
      // }

      this.$axios
        .post(this.ENDPOINTS.CADASTRAR_AGENTE, dados)
        .then(response => {
          if (response) {
            // dados cadastrais
            (this.cadastro.dados_cadastrais.status = "ATIVO"),
              (this.cadastro.dados_cadastrais.razao_social = ""),
              (this.cadastro.dados_cadastrais.cnpj = ""),
              (this.cadastro.dados_cadastrais.cep = ""),
              (this.cadastro.dados_cadastrais.estado = ""),
              (this.cadastro.dados_cadastrais.cidade = ""),
              (this.cadastro.dados_cadastrais.bairro = ""),
              (this.cadastro.dados_cadastrais.logradouro = ""),
              (this.cadastro.dados_cadastrais.complemento = ""),
              (this.cadastro.dados_cadastrais.nome_representante = ""),
              (this.cadastro.dados_cadastrais.cpf = ""),
              (this.cadastro.dados_cadastrais.rg = ""),
              (this.cadastro.dados_cadastrais.rg_orgao = ""),
              (this.cadastro.dados_cadastrais.email = ""),
              (this.cadastro.dados_cadastrais.celular = ""),
              (this.cadastro.dados_cadastrais.regional = "");

            // comissao e antecipacao
            (this.cadastro.comissao_antecipacao.comissao = ""),
              (this.cadastro.comissao_antecipacao.porcentagem_web = ""),
              (this.cadastro.comissao_antecipacao.porcentagem_rede = ""),
              (this.cadastro.comissao_antecipacao.antecipacao = ""),
              (this.cadastro.comissao_antecipacao.taxa_personalizada = ""),
              (this.cadastro.comissao_antecipacao.dias_antecipacao = ""),
              (this.cadastro.comissao_antecipacao.taxa_mes = ""),
              (this.cadastro.comissao_antecipacao.observacoes = ""),
              // dados bancarios
              (this.cadastro.dados_bancarios.nome_titular = ""),
              (this.cadastro.dados_bancarios.banco = ""),
              (this.cadastro.dados_bancarios.agencia = ""),
              (this.cadastro.dados_bancarios.tipo_de_conta = ""),
              (this.cadastro.dados_bancarios.nome_titular = ""),
              (this.cadastro.dados_bancarios.numero_conta = ""),
              (this.cadastro.dados_bancarios.digito = ""),
              // documentos
              (this.cadastro.documentos.contrato_social = ""),
              (this.cadastro.documentos.comprovante_endereco = ""),
              (this.cadastro.documentos.procuracao = ""),
              // contratos
              (this.cadastro.contratos.template = "");

            router.push("/pessoas/agentes");
          }
          this.cadastro.loading = false;
        })
        .catch(() => {
          this.cadastro.loading = false;
        });
    },

    // ---- FUNÇÃO PARA REDEFINIR A SENHA ---- //
    async trocarSenha() {
      let idusuario = this.$axios.getLocal("oe_user_info").data.idusuario;
      if (this.user.old_password.length == 0) {
        this.$config.alert(
          "Insira sua senha atual!",
          this.$config.dados.errorColor
        );
        this.$usuario.user.error.old_password = "Insira sua senha atual";
        return;
      }
      // if(this.validaSenha(this.cadastro.senha) < 60)
      //     { this.$config.alert(this.$t_('preencha_senha_corret'), this.$config.dados.errorColor); this.$usuario.cadastro.error.senha = this.$t_('preencha_senha_corret'); return }
      if (this.user.senha != this.user.senha2) {
        this.$config.alert(
          "As senhas são incompatíveis!",
          this.$config.dados.errorColor
        );
        this.$usuario.user.error.senha2 = "As senhas são incompatíveis!";
        return;
      }
      this.$axios
        .put(
          this.ENDPOINTS.ALTERAR_SENHA + idusuario,
          JSON.stringify({
            senha_antiga: this.user.old_password,
            senha_nova: this.user.senha,
          })
        )
        .then(response => {
          if (response) {
            sessionStorage.removeItem("token");
            localStorage.removeItem("token");
            this.$axios.destroy(true);
            this.user.old_password = "";
            this.user.show_old_pass = "password";
            this.user.senha = "";
            this.user.show_senha = "password";
            this.user.senha2 = "";
            this.user.show_senha2 = "password";
            if (location.pathname != "login") {
              setTimeout(() => {
                router.push("/");
              }, 3000);
            }
          }
        });
    },

    filtroAgentes() {
      if (this.filter.nome != "") {
        this.filtros.push({
          campo: "nome",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.nome,
        });
      } else if (this.filter.documento != "") {
        this.filtros.push({
          campo: "documento",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.documento,
        });
      } else if (this.filter.status != "") {
        this.filtros.push({
          campo: "status",
          tipo: "string",
          valor: this.filter.status,
        });
      } else if (this.filter.dataInicio != "") {
        this.filtros.push({
          campo: "ins_dthr",
          tipo: "date",
          orientacao: "maior",
          valor: this.filter.dataInicio + " 00:00",
        });
      } else if (this.filter.dataFim != "") {
        this.filtros.push({
          campo: "ins_dthr",
          tipo: "date",
          orientacao: "menor",
          valor: this.filter.dataFim + " 23:59",
        });
      } else if (this.filter.tipo_pessoa != "") {
        this.filtros.push({
          campo: "tipo_pessoa",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.tipo_pessoa,
        });
      } else {
        this.filtros = [];
      }
      let filtered = this.filtros;
      this.$axios
        .post(
          this.ENDPOINTS.LISTAR_AGENTES,
          JSON.stringify({ filtros: filtered })
        )
        .then(response => {
          this.agentes = response;
        });
    },

    // ---- // ---------------------------------------- FUNÇÕES AUXILIARES ---------------------------------------- // ---- //

    // ---- FUNÇÃO QUE VALIDA O CADASTRO ---- //
    async validarCadastro() {
      // VALIDAÇÃO DOS DADOS CADASTRAIS
      if (
        this.cadastro.dados_cadastrais.razao_social.length < 5 ||
        this.cadastro.dados_cadastrais.razao_social == ""
      ) {
        this.$config.alert(
          "Preencha a razão social corretamente!",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.razao_social =
          "Preencha a razão social corretamente!";
        return;
      }

      if (
        this.cadastro.dados_cadastrais.cnpj.length < 18 ||
        this.cadastro.dados_cadastrais.cnpj == ""
      ) {
        this.$config.alert(
          "Preencha o CNPJ corretamente!",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.cnpj =
          "Preencha o CNPJ corretamente!";
        return;
      }

      if (!this.$config.validarCNPJ(this.cadastro.dados_cadastrais.cnpj)) {
        this.$config.alert("CNPJ inválido!", this.$config.dados.errorColor);
        this.cadastro.dados_cadastrais.error.cnpj = "CNPJ inválido!";
        return;
      }

      if (
        this.cadastro.dados_cadastrais.nome_representante.length < 5 ||
        this.cadastro.dados_cadastrais.nome_representante == ""
      ) {
        this.$config.alert(
          "Preencha o nome do representante corretamente!",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.nome_representante =
          "Preencha o nome do representante corretamente!";
        return;
      }

      if (
        this.cadastro.dados_cadastrais.cpf.length < 14 ||
        this.cadastro.dados_cadastrais.cpf == ""
      ) {
        this.$config.alert(
          "Preencha o CPF corretamente!",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.cpf =
          "Preencha o CPF corretamente!";
        return;
      }

      if (!this.$config.validarCPF(this.cadastro.dados_cadastrais.cpf)) {
        this.$config.alert("CPF inválido!", this.$config.dados.errorColor);
        this.cadastro.dados_cadastrais.error.cpf = "CPF inválido!";
        return;
      }

      if (
        this.cadastro.dados_cadastrais.rg.length < 5 ||
        this.cadastro.dados_cadastrais.rg == ""
      ) {
        this.$config.alert("Preencha o RG corretamente!", "error");
        this.cadastro.dados_cadastrais.error.rg = "Preencha o RG corretamente!";
        return;
      }

      if (
        this.cadastro.dados_cadastrais.rg_orgao.length < 3 ||
        this.cadastro.dados_cadastrais.rg_orgao == ""
      ) {
        this.$config.alert(
          "Preencha o Orgão Expedidor do RG corretamente!",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.rg_orgao =
          "Preencha o Orgão Expedidor do RG corretamente!";
        return;
      }

      if (
        this.cadastro.dados_cadastrais.email.length < 5 ||
        this.cadastro.dados_cadastrais.email == ""
      ) {
        this.$config.alert(
          "Preencha o e-mail corretamente!",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.email =
          "Preencha o e-mail corretamente!";
        return;
      }

      if (!this.$config.validarEmail(this.cadastro.dados_cadastrais.email)) {
        this.$config.alert("E-mail inválido!", this.$config.dados.errorColor);
        this.cadastro.dados_cadastrais.error.email = "E-mail inválido!";
        return;
      }

      if (
        this.cadastro.dados_cadastrais.celular.length < 15 ||
        this.cadastro.dados_cadastrais.celular == ""
      ) {
        this.$config.alert(
          "Preencha o celular corretamente!",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.celular =
          "Preencha o celular corretamente!";
        return;
      }

      if (this.cadastro.dados_cadastrais.regional == "") {
        this.$config.alert(
          "Selecione uma regional!",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.regional =
          "Selecione uma regional!";
        return;
      }

      if (this.cadastro.dados_cadastrais.status == "") {
        this.$config.alert(
          "Selecione um status para o agente!",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.status =
          "Selecione um status para o agente";
        return;
      }

      if (
        this.cadastro.dados_cadastrais.cep.length < 5 ||
        this.cadastro.dados_cadastrais.cep == ""
      ) {
        this.$config.alert(
          "Preencha o CEP corretamente!",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.cep =
          "Preencha o CEP corretamente!";
        return;
      }

      if (this.cadastro.dados_cadastrais.estado == "") {
        this.$config.alert(
          "Selecione o estado!",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.estado = "Selecione o estado!";
        return;
      }

      if (this.cadastro.dados_cadastrais.cidade == "") {
        this.$config.alert(
          "Selecione a cidade!",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.cidade = "Selecione a cidade!";
        return;
      }

      if (this.cadastro.dados_cadastrais.bairro == "") {
        this.$config.alert(
          "Preencha o bairro corretamente!",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.bairro =
          "Preencha o bairro corretamente!";
        return;
      }

      if (this.cadastro.dados_cadastrais.logradouro == "") {
        this.$config.alert(
          "Preencha o endereço corretamente!",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.logradouro =
          "Preencha o endereço corretamente!";
        return;
      }

      // VALIDAÇÃO COMISSÃO E ANTECIPAÇÃO
      // if(this.cadastro.comissao_antecipacao.comissao == '')
      //     { this.$config.alert('Selecione a regra de comissão!', this.$config.dados.errorColor); this.cadastro.comissao_antecipacao.error.comissao = 'Selecione a regra de comissão!'; return }

      //     if(this.cadastro.comissao_antecipacao.comissao != 'default') {
      //         if(this.cadastro.comissao_antecipacao.porcentagem_web == '')
      //             { this.$config.alert('Preencha a porcentagem personalizada para venda web corretamente!', this.$config.dados.errorColor); this.cadastro.comissao_antecipacao.error.porcentagem_web = 'Preencha a porcentagem personalizada para venda web corretamente!'; return }

      //         if(this.cadastro.comissao_antecipacao.porcentagem_rede == '')
      //             { this.$config.alert('Preencha a porcentagem personalizada para rede de vendas corretamente!', this.$config.dados.errorColor); this.cadastro.comissao_antecipacao.error.porcentagem_rede = 'Preencha a porcentagem personalizada para rede de vendas corretamente!'; return }
      //     }

      // if(this.cadastro.comissao_antecipacao.antecipacao == '')
      //     { this.$config.alert('Selecione a regra de antecipação!', this.$config.dados.errorColor); this.cadastro.comissao_antecipacao.error.comissao = 'Selecione a regra de antecipação!'; return }

      //     if(this.cadastro.comissao_antecipacao.antecipacao != 'default') {
      //         if(this.cadastro.comissao_antecipacao.taxa_personalizada == '')
      //             { this.$config.alert('Preencha a taxa personalizada de antecipação corretamente!', this.$config.dados.errorColor); this.cadastro.comissao_antecipacao.error.taxa_personalizada = 'Preencha a taxa personalizada de antecipação corretamente!'; return }

      //         if(this.cadastro.comissao_antecipacao.dias_antecipacao == '')
      //             { this.$config.alert('Preencha os dias de antecipação corretamente!', this.$config.dados.errorColor); this.cadastro.comissao_antecipacao.error.dias_antecipacao = 'Preencha os dias de antecipação corretamente!'; return }

      //         if(this.cadastro.comissao_antecipacao.taxa_mes == '')
      //             { this.$config.alert('Preencha a taxa mensal de antecipação corretamente!', this.$config.dados.errorColor); this.cadastro.comissao_antecipacao.error.taxa_mes = 'Preencha a taxa mensal de antecipação corretamente!'; return }
      //     }

      // VALIDAÇÃO DOS DADOS BANCÁRIOS
      // if(this.cadastro.dados_bancarios.nome_titular.length < 5 || this.cadastro.dados_bancarios.nome_titular == '')
      //     { this.$config.alert('Preencha o nome do títular corretamente!', this.$config.dados.errorColor); this.cadastro.dados_bancarios.error.nome_titular = 'Preencha o nome do títular corretamente!'; return }

      // if(this.cadastro.dados_bancarios.banco == '')
      //     { this.$config.alert('Selecione o banco!', this.$config.dados.errorColor); this.cadastro.dados_bancarios.error.banco = 'Selecione o banco!'; return }

      // if(this.cadastro.dados_bancarios.agencia.length < 3 || this.cadastro.dados_bancarios.agencia == '')
      //     { this.$config.alert('Preencha o nº da agência corretamente!', this.$config.dados.errorColor); this.cadastro.dados_bancarios.error.agencia = 'Preencha o nº da agência corretamente!'; return }

      // if(this.cadastro.dados_bancarios.tipo_de_conta == '')
      //     { this.$config.alert('Selecione o tipo de conta!', this.$config.dados.errorColor); this.cadastro.dados_bancarios.error.tipo_de_conta = 'Selecione o tipo de conta!'; return }

      // if(this.cadastro.dados_bancarios.numero_conta.length < 5 || this.cadastro.dados_bancarios.numero_conta == '')
      //     { this.$config.alert('Preencha o nº da conta corretamente!', this.$config.dados.errorColor); this.cadastro.dados_bancarios.error.numero_conta = 'Preencha o nº da conta corretamente!'; return }

      // if(this.cadastro.dados_bancarios.digito.length < 1 || this.cadastro.dados_bancarios.digito == '')
      //     { this.$config.alert('Preencha o nº do digito corretamente!', this.$config.dados.errorColor); this.cadastro.dados_bancarios.error.digito = 'Preencha o nº do digito corretamente!'; return }

      // VALIDAÇÃO DOCUMENTOS
      // if(this.cadastro.documentos.contrato_social == '')
      //     { this.$config.alert('Faça upload do contrato social!', this.$config.dados.errorColor); this.cadastro.documentos.error.contrato_social = 'Faça upload do contrato social!'; return }

      // if(this.cadastro.documentos.comprovante_endereco == '')
      //     { this.$config.alert('Faça upload do comprovante de endereço!', this.$config.dados.errorColor); this.cadastro.documentos.error.comprovante_endereco = 'Faça upload do comprovante de endereço!'; return }

      // VALIDAÇÃO CONTRATOS
      // if(this.cadastro.contratos.template == '')
      //     { this.$config.alert('Selecione um template de contrato!', this.$config.dados.errorColor); this.cadastro.contratos.error.template = 'Selecione um template de contrato!'; return }

      if (this.agentesAddEdit == "edit") {
        this.alterarAgente();
        return;
      }

      this.cadastrarAgente();
    },

    // ---- FUNÇÃO QUE DA SCROLL ---- //
    scrollCadastro() {
      window.scrollTo({
        top: 720,
        left: 0,
        behavior: "smooth",
      });
    },
  },
});
